import { render, staticRenderFns } from "./goldAnalysis.vue?vue&type=template&id=f504a58c&"
import script from "./goldAnalysis.vue?vue&type=script&lang=js&"
export * from "./goldAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f504a58c')) {
      api.createRecord('f504a58c', component.options)
    } else {
      api.reload('f504a58c', component.options)
    }
    module.hot.accept("./goldAnalysis.vue?vue&type=template&id=f504a58c&", function () {
      api.rerender('f504a58c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameData/actionAnalysis/goldAnalysis.vue"
export default component.exports